module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), (_vm.$route.query.status !== "canceled" && _vm.$route.query.status !== "rescheduled") ? _c('h1', [_vm._v("\n      Hi " + _vm._s(_vm.full_name) + ", "), _c('br'), _vm._v(" Thank you for attending the Teaching Practice Session. Please see your final demo schedule: "), _c('br'), _vm._v(" Please make sure to finish modules 4-10. These must be finished prior to the Final Demo.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('h1', [_vm._v("Hi " + _vm._s(_vm.full_name) + ", your demo appointment has been rescheduled.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ", you've cancelled your scheduled demo time. You may request a new appointment. ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('h4', [_vm._v("Your scheduled demo time")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "date_select"
  }), _vm._v(" "), _c('div', {
    staticClass: "schedule_de clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Time Zone：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.appointment.timezone))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Date & Time：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.date_time))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style reschedule",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.showPop
    }
  }, [_vm._v(_vm._s(_vm.$route.query.status == "canceled" ? 'Schedule' : 'Reschedule'))])]), _vm._v(" "), (_vm.date_time) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style cancel",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.cancel_apo
    }
  }, [_vm._v("Cancel Appointment")])]) : _vm._e(), _vm._v(" "), (_vm.need_help) ? _c('a', {
    staticClass: "need_help",
    attrs: {
      "href": ("mailto:" + _vm.need_help)
    }
  }, [_vm._v("Have questions? Email here")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "session session-s"
  }, [_c('h4', [_vm._v("Training Modules")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de no_bg"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.urls.trainingModulesLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.urls.trainingModulesLink))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reschedule_show),
      expression: "reschedule_show"
    }],
    staticClass: "pop"
  }, [_c('reschedule', {
    attrs: {
      "scheduled-time-zone": _vm.appointment.timezone_key,
      "scheduled-start-time": _vm.appointment.start_time,
      "scheduled-end-time": _vm.appointment.end_time,
      "time-zone": _vm.options,
      "book-type": _vm.bookType,
      "sureHandler": _vm.confirmOpen,
      "queryStatus": _vm.$route.query.status
    },
    on: {
      "getTutorInfo": _vm.getTutorInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])]), _vm._v(" "), _c('cancel-confirm', {
    ref: "cancelConfirm"
  }), _vm._v(" "), (_vm.$route.query.status == "assigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=jUeFCKHuyngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=iMvTCMvGsngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("Where：")]), _vm._v(" "), _c('p', [_vm._v("Your teaching practice session will be conducted on AC."), _c('br'), _vm._v(" Please contact your recruiter for your AC login credentials.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n        Please contact your recruiter if you need any assistance, or if you have any questions."), _c('br'), _vm._v(" Failure to attend your scheduled demo may disqualify you for the position.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session"
  }, [_c('h4', [_vm._v("Live Training Session")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Please take note of these further instructions for the session:")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("Please add trainer as a contact on Zoom 30 minutes before the training and send them your updated speed test result link as a confirmation for "), _c('br'), _vm._v("the training session.")]), _vm._v(" "), _c('li', [_vm._v("Please have your HEADSET set up for the session. You need a corded headset (USB plugged) with noise cancellation feature. ")]), _vm._v(" "), _c('li', [_vm._v("Please have the right background set up. You should have a solid light colored background with adequate lighting and no distractions.")]), _vm._v(" "), _c('li', [_vm._v("You must be using a laptop or PC (Windows or Mac) – Do not use a mobile or tablet.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd07cfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/demo/demo.vue
// module id = 819
// module chunks = 1